<template>
  <div :class="classes">
     <pt-page-title title="新建税务项目"></pt-page-title>
    <pt-sub-title title="税务项目信息"></pt-sub-title>
    <table :class="$style['taxation-message-fprm-table']" v-loading="loading">
        <pt-form-list-item label="项目名称：" :required="true">
            <wt-input data-vv-as="项目名称" name="name"  v-validate="'required'" v-model="formValue.xmmc" ></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="税率：" :required="true">
             <wt-input data-vv-as="项目名称" name="name" v-model="formValue.sl"  v-validate="'required|numeric|min_value:0|max_value:100'">
                 <el-button slot="append">%</el-button>
             </wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="单位：" :required="true">
             <wt-input data-vv-as="项目名称" name="name"  v-validate="'required'" v-model="formValue.dw" ></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="项目编码：" :required="true">
             <wt-input data-vv-as="项目名称" name="name"  v-validate="'required'" v-model="formValue.xmbm" ></wt-input>
        </pt-form-list-item>
    </table>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-taxation-project-form'

export default {
  name: 'pt-taxation-project-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    taxDetail: {
      type: [Object, String],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formValue: this.taxDetail || {
      }
    }
  },
  watch: {
    taxDetail (val) {
      this.formValue = val
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.taxation-message-fprm-table{
    padding:0 20px;
    max-width: 450PX;
}
</style>
